export default {
  mutations: {
    SET_PAYMENT_STATUS_LIST: 'SET_PAYMENT_STATUS_LIST',
  },
  getters: {
    GET_PAYMENT_STATUS_LIST: 'GET_PAYMENT_STATUS_LIST',
  },
  actions: {
    PAYMENT_STATUS_LIST: 'PAYMENT_STATUS_LIST',
  },
};
